export default {
	"userOrganization": {
		"tipsUnbind": "解除",
		"allStatus": "全部状态",
		"userName": "姓名",
		"mobile": "手机",
		"selectRole": "请选择角色",
		"selectDepartment": "请选择部门",
		"noSubordinate": "没有下级",
		"noMatchDepartment": "暂无匹配部门",
		"isDisabled": "已禁用",
		"department": "部门",
		"onlyCurrentOrganization": "只看当前组织人员",
		"organization": "组织",
		"organizationName": "组织名称",
		"role": "角色",
		"roleName": "角色名称",
		"addNewRole": "添加新角色",
		"addUser": "添加人员",
		"employeeNumber": "员工编号",
		"userGender": "性别",
		"userPosition": "职位",
		"userEmail": "邮箱",
		"telephone": "座机",
		"userWechat": "微信",
		"userModify": "人员修改",
		"modifyAvatar": "修改头像",
		"credentialNo": "证件号",
		"addOrganization": "添加组织",
		"confirmRemoveRole": "确定移除当前用户角色吗？",
		"createUserSuccess": "Create user successfully",
		"editUserSuccess": "Edit user successfully",
		"removeUserSuccess": "Remove user successfully",
		"enableUserSuccess": "Enable user successfully",
		"disableUserSuccess": "Disable user successfully"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/userOrganization/userOrganization.js